import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

interface CourseProps {
  active: boolean;
}

export const Screen = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  width: 100vw;
  height: 100%;
  max-height: 100%;

  padding: 5rem;

  @media (max-width: 1224px) {
    padding: 5rem 3rem;
  }

  @media (max-width: 800px) {
    padding: 2rem 1.5rem;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  h2 {
    font-size: 2rem;
    font-weight: 600;
    color: #2e2e2e;
  }

  h3 {
    margin-bottom: 3rem;
  }
`;

export const Courses = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 3rem;

  a + a {
    margin-left: 1rem;
  }

  a {
    text-decoration: none;
    color: #1d62d1;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    a + a {
      margin-left: 0;
      margin-top: 2rem;
    }
  }
`;

export const Course = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  border: 2px solid;
  border-color: #f0f1f5;
  border-radius: 1rem;
  transition: all 0.2s ease-in-out;
  font-weight: 500;
  cursor: pointer;
`;
